import React from 'react';
const testimonials = [{
  initials: 'RG',
  quote: 'Compré un domingo. El lunes entré a la cancha con todo listo. Nunca más improviso.',
  name: 'Roberto G.',
  country: 'México 🇲🇽'
}, {
  initials: 'CM',
  quote: 'Tres jugadoras estancadas subieron de nivel en el primer mes con el Tomo 2.',
  name: 'Camila M.',
  country: 'Colombia 🇨🇴'
}, {
  initials: 'JA',
  quote: 'Antes tardaba 1 hora armando sesiones tácticas. Ahora 5 minutos.',
  name: 'Javier A.',
  country: 'Chile 🇨🇱'
}, {
  initials: 'PV',
  quote: 'Las fichas de evaluación eliminaron las preguntas de los padres. Progreso con números.',
  name: 'Patricia V.',
  country: 'Perú 🇵🇪'
}, {
  initials: 'AS',
  quote: 'Mi tasa de retención pasó del 40% al 80% con el sistema del Tomo 6.',
  name: 'Andrés S.',
  country: 'España 🇪🇸'
}, {
  initials: 'LR',
  quote: 'El Reglamento Interno eliminó las quejas sobre tiempo de juego. Primera vez en mi carrera.',
  name: 'Lucía R.',
  country: 'Ecuador 🇪🇨'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-[#0A0A0F] py-14 px-4" data-id="element-231">
      <div className="max-w-3xl mx-auto" data-id="element-232">
        <div className="text-center mb-8" data-id="element-233">
          <h2 className="text-2xl sm:text-3xl font-black text-white mb-1" data-id="element-234">
            Lo que dicen los{' '}
            <span className="text-[#FF6B00]" data-id="element-235">entrenadores</span>
          </h2>
          <p className="text-[#B0B0C0] text-sm" data-id="element-236">
            ⭐⭐⭐⭐⭐ 4.9/5 · +300 entrenadores en 12 países
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-237">
          {testimonials.map(t => <div key={t.initials} className="bg-[#16161F] border border-[#FF6B0033] rounded-xl px-4 py-3.5 flex items-start gap-3" data-id="element-238">
              <div className="w-9 h-9 rounded-full bg-[#FF6B00] flex items-center justify-center text-white font-black text-xs flex-shrink-0 mt-0.5" data-id="element-239">
                {t.initials}
              </div>
              <div className="flex-1 min-w-0" data-id="element-240">
                <p className="text-white text-xs sm:text-sm leading-relaxed italic mb-1.5" data-id="element-241">
                  "{t.quote}"
                </p>
                <p className="text-[10px] sm:text-xs" data-id="element-242">
                  <span className="text-white font-bold" data-id="element-243">{t.name}</span>
                  <span className="text-[#FF6B00] font-medium" data-id="element-244">
                    {' '}
                    · {t.country}
                  </span>
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}